import { render, staticRenderFns } from "./projectContactsCard.vue?vue&type=template&id=5ab6e2e2"
import script from "./projectContactsCard.vue?vue&type=script&lang=ts"
export * from "./projectContactsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports